import { defineComponent as _defineComponent } from 'vue'
import {
	computed,
	watch,
	onMounted,
	onBeforeUnmount,
	ref,
	onActivated,
} from 'vue';
import { useRoute } from 'vue-router';
import { Search } from '@element-plus/icons-vue';
import store, { config, userConfig, pageSizeConfig } from '@/store';
import searchApi from '@/api/search';
import router from '@/router';
import chapterApi from '@/api/chapter';
import { global_set, global_set_json } from '@/utils';
import manga from '@/components/manga.vue';
import chapter from '@/components/chapter.vue';
import mediaPager from '@/components/media-pager.vue';
import { ElMessage } from 'element-plus';
import { pageSizeConfigType, screenType } from '@/type/store';
import { mangaPageSize, chapterPageSize } from '@/store/page-size';
import listSkeleton from '@/components/list-skeleton.vue';
import queue from '@/store/quque';


const __default__ = { name: 'search' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

let loading = ref(false);
const searchText = ref('');
const searchType = ref('manga');

const route = useRoute();

let pageSizes: number[] = [];
let defaultPageSize = 10;

get_page_size_array();

function get_page_size_array() {
	// 获取默认的页面容量
	const screen: screenType = config.screenType;

	const pageSizesConfig = searchType.value === 'manga' ? mangaPageSize : chapterPageSize;

	pageSizes = pageSizesConfig[screen];
	defaultPageSize = pageSizesConfig[screen][0];
}
let page = ref(1);
let count = ref(0);
let list = ref([]);
let mangaInfo = ref({});
let menuPoster = '';

// 切换排序规则时 重新加载列表
watch(
	() => userConfig.order,
	() => {
		page_change(1);
	}
);
onMounted(() => {
	touch_page_change();
});

// KeepAlive相关联 生命周期
onActivated(() => {
	const paramsSearchText = route.params.searchText;

	if (paramsSearchText) {
		searchText.value = String(paramsSearchText);
		searchType.value = String(route.params.searchType);
		page_change();
		route.params.searchText = '';
	}
});

async function do_search() {
	const res: any = await searchApi.get(searchText.value, searchType.value, 1, defaultPageSize);
	list.value = res.list;
}

/**
 * 清空方法
 */
function clear() {
	list.value = [];
}

function touch_page_change() {

	const listDom = document.querySelector('.touch-dom');
	if (listDom === null) return;

	// 获取手指初始坐标和盒子的原来位置
	var startX = 0;
	// 获取盒子原来的位置
	var x = 0;
	var moveX = 0;

	listDom.addEventListener('touchstart', function (this: HTMLDivElement, e: any) {
		if (config.viewType === 'list') return;
		// 得到初始的手指坐标
		startX = e.targetTouches[0].pageX;
		// 获取盒子坐标
		x = this.offsetLeft;
	})

	listDom.addEventListener('touchmove', function (this: HTMLDivElement, e: any) {
		if (config.viewType === 'list') return;
		// 手指的移动距离= 手指移动之后的坐标 - 手指初始的坐标
		moveX = e.targetTouches[0].pageX - startX;
		// 移动盒子，盒子原来的位置+手指移动的距离
		this.style.left = x + moveX + 'px';
		// 阻止屏幕滚动行为
		e.preventDefault();
	})

	listDom.addEventListener('touchend', function (this: HTMLDivElement, e) {
		if (config.viewType === 'list') return;
		this.style.left = '0';

		// 向左滑动,向右翻页
		if (moveX < -100 && page.value < count.value) {
			page_change(++page.value);
		}

		// 向右滑动,向左翻页
		if (moveX > 100 && page.value > 1) {
			page_change(--page.value);
		}


		moveX = 0;
	})
}

/**
 * 跳页
 * @param page
 * @param pageSize
 */
async function page_change(
	pageParams = 1,
	pageSize: number = defaultPageSize
) {
	// 获取页码
	page.value = pageParams;
	// 加载骨架屏
	loading.value = true;
	// 取消封面加载任务
	queue.clear();
	// 清空数据 避免缓存
	list.value = [];

	if (!searchText.value) {
		ElMessage.warning('请输入搜索关键词！');
		return false;
	}

	const res: any = await searchApi.get(
		searchText.value,
		searchType.value,
		page.value,
		pageSize,
		userConfig.order
	);
	list.value = res.list;
	count.value = res.count;

	// 结束加载
	loading.value = false;
}

function reload() {
	/*  关于首页首次加载的页面容量 因逻辑bug暂时不处理
		const screenType = config.screenType;
		const pageSize = mediaPageSize[screenType];
	*/
	page_change(1);
}

/**
 * 打开右侧菜单
 */
function context_menu(mangaInfo: any, key: number) {
	menuPoster = (list[key] as any).blob;
	mangaInfo = mangaInfo;
	config.rightSidebar = true;
}

// 章节方法
async function go_browse(item: any) {
	const chapterId = item.chapterId;
	const chapterName = item.chapterName;
	const chapterPath = item.chapterPath;
	const chapterType = item.chapterType;
	const chapterCover = item.chapterCover;
	const browseType = item.browseType;

	// 缓存章节信息
	global_set('chapterId', chapterId);
	global_set('chapterName', chapterName);
	global_set('chapterPath', chapterPath);
	global_set('chapterType', chapterType);
	global_set('chapterCover', chapterCover);

	// 加载章节列表
	const res = await chapterApi.get(item.mangaId);
	global_set_json('chapterList', res.list);

	let page = 1;

	router.push({
		name: browseType,
		query: {
			chapterId,
		},
		params: { page },
	});
}

const __returned__ = { get loading() { return loading }, set loading(v) { loading = v }, searchText, searchType, route, get pageSizes() { return pageSizes }, set pageSizes(v) { pageSizes = v }, get defaultPageSize() { return defaultPageSize }, set defaultPageSize(v) { defaultPageSize = v }, get_page_size_array, get page() { return page }, set page(v) { page = v }, get count() { return count }, set count(v) { count = v }, get list() { return list }, set list(v) { list = v }, get mangaInfo() { return mangaInfo }, set mangaInfo(v) { mangaInfo = v }, get menuPoster() { return menuPoster }, set menuPoster(v) { menuPoster = v }, do_search, clear, touch_page_change, page_change, reload, context_menu, go_browse, get Search() { return Search }, get config() { return config }, manga, chapter, mediaPager, get screenType() { return screenType }, listSkeleton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})